import {
  FIELD_NAMES,
  ADDITIONAL_FIELDS_NAMES,
  createInformationSourceValue,
} from 'constants/contactForm';
import { getCaptchaToken } from 'shared/api';

const deleteEmptyFields = dataObject =>
  Object.fromEntries(Object.entries(dataObject).filter(([, value]) => value !== ''));

export const configureFormData = async rawData =>
  deleteEmptyFields({
    // Персональная информация
    [FIELD_NAMES.fullname]: rawData[FIELD_NAMES.fullname],
    [FIELD_NAMES.birthday]: rawData[FIELD_NAMES.birthday].split('.').reverse().join('-'),
    [FIELD_NAMES.country]: rawData[FIELD_NAMES.country],
    [FIELD_NAMES.city]: rawData[FIELD_NAMES.city],

    // Контактная информация
    [FIELD_NAMES.phone]: rawData[FIELD_NAMES.phone],
    [FIELD_NAMES.email]: rawData[FIELD_NAMES.email],
    [FIELD_NAMES.telegram]: rawData[FIELD_NAMES.telegram],

    // Образование
    [FIELD_NAMES.education]: rawData[FIELD_NAMES.education],
    [FIELD_NAMES.englishLevel]: rawData[FIELD_NAMES.englishLevel],

    //Направление стажировки
    specializations: [
      {
        [FIELD_NAMES.specialization]: rawData[FIELD_NAMES.specialization],
        [FIELD_NAMES.direction]: [rawData[FIELD_NAMES.direction]],
        [FIELD_NAMES.additionalEducation]: rawData[FIELD_NAMES.additionalEducation],
      },
    ],

    // Остальные поля формы
    [FIELD_NAMES.informationSource]: createInformationSourceValue(
      rawData[FIELD_NAMES.informationSource],
      rawData[FIELD_NAMES.source],
      rawData[FIELD_NAMES.sourceOnlineSchool],
    ),

    // Дополнительные поля
    [ADDITIONAL_FIELDS_NAMES.captchaToken]: await getCaptchaToken(),
    [ADDITIONAL_FIELDS_NAMES.referrer]: window.location.search,
  });
